import React from 'react'
import {useFocusEffect} from '@react-navigation/native'
import {type NativeStackScreenProps} from '@react-navigation/native-stack'

import {type CommonNavigatorParams} from '#/lib/routes/types'
import {usePremium} from '#/state/premium'
import {useSetMinimalShellMode} from '#/state/shell'
import {RoomsPaywall} from '#/screens/Rooms/RoomsPaywall'
import * as Layout from '#/components/Layout'
import {ThreeVideoFeed} from './ThreeVideoFeed'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'ThreeVideos'>

export function ThreeVideosScreen({}: Props) {
  const setMinimalShellMode = useSetMinimalShellMode()
  const {isPremium, isLoading: isPremiumLoading} = usePremium()

  useFocusEffect(
    React.useCallback(() => {
      setMinimalShellMode(false)
    }, [setMinimalShellMode]),
  )

  if (!isPremium && !isPremiumLoading) {
    return (
      <Layout.Screen testID="threeVideosScreen">
        <RoomsPaywall />
      </Layout.Screen>
    )
  }

  return (
    <Layout.Screen testID="threeVideosScreen">
      <ThreeVideoFeed testID="threeVideosFeed" />
    </Layout.Screen>
  )
}
